

require('./directive');

var _squid = require('squid');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOSepaAgreementRoute', function () {
    return _squid.$ComponentRoute.extend('XOSepaAgreementRoute', {
        name: 'sepaAgreement',

        directive: 'xo-sepa-agreement',
        titleContent: 'directDebitAgreement.sepaTitle',

        trackingData: {
            fptiState: 'sepa_agreement',
            buzname: {
                'fullpage': {
                    'pagename': '%::sepa_agreement',
                    'pagename2': '%::sepa_agreement:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },

        loginRequired: true,

        children: []
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/route.js
// module id = ../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/route.js
// module chunks = 0